module.exports = __webpack_public_path__ + "img/ic-nav-tuktuk--next-circle-white.0f5da5b6.svg";